import { defineMessages } from 'react-intl';

export default defineMessages({
  notFoundMessage: {
    id: 'app.components.DynamicForm.notFoundMessage',
    defaultMessage: 'Erro ao carregar mensagem',
  },
  accessibility: {
    id: 'app.components.DynamicForm.accessibility',
    defaultMessage: 'Acessibilidade',
  },
  balcony: {
    id: 'app.components.DynamicForm.balcony',
    defaultMessage: 'Varanda',
  },
  bathroom: {
    id: 'app.components.DynamicForm.bathroom',
    defaultMessage: 'Banheiro',
  },
  bedroom: {
    id: 'app.components.DynamicForm.bedroom',
    defaultMessage: 'Quarto',
  },
  contacts: {
    id: 'app.components.DynamicForm.contacts',
    defaultMessage: 'Contato',
  },
  doorman: {
    id: 'app.components.DynamicForm.doorman',
    defaultMessage: 'Portaria',
  },
  externalAccessibility: {
    id: 'app.components.DynamicForm.externalAccessibility',
    defaultMessage: 'Acessibilidade',
  },
  externalItems: {
    id: 'app.components.DynamicForm.externalItems',
    defaultMessage: 'Itens',
  },
  generalItems: {
    id: 'app.components.DynamicForm.generalItems',
    defaultMessage: 'Itens gerais',
  },
  house: {
    id: 'app.components.DynamicForm.house',
    defaultMessage: 'Checklist',
  },
  houseAccessibility: {
    id: 'app.components.DynamicForm.houseAccessibility',
    defaultMessage: 'Acessibilidade',
  },
  houseAddress: {
    id: 'app.components.DynamicForm.houseAddress',
    defaultMessage: 'Endereço',
  },
  houseFeatures: {
    id: 'app.components.DynamicForm.houseFeatures',
    defaultMessage: 'Características',
  },
  kitchen: {
    id: 'app.components.DynamicForm.kitchen',
    defaultMessage: 'Cozinha',
  },
  laundry: {
    id: 'app.components.DynamicForm.laundry',
    defaultMessage: 'Área de serviço',
  },
  livingRoom: {
    id: 'app.components.DynamicForm.livingRoom',
    defaultMessage: 'Sala de estar',
  },
  photoSession: {
    id: 'app.components.DynamicForm.photoSession',
    defaultMessage: 'Observações sobre a sessão',
  },
  propertyDescription: {
    id: 'app.components.DynamicForm.propertyDescription',
    defaultMessage: 'Descreva melhor o imóvel (opcional)',
  },
  propertyMaintananceCondition: {
    id: 'app.components.DynamicForm.propertyMaintananceCondition',
    defaultMessage: 'Como está o imóvel?',
  },
  sun: {
    id: 'app.components.DynamicForm.sun',
    defaultMessage: 'Sol',
  },
  windows: {
    id: 'app.components.DynamicForm.windows',
    defaultMessage: 'Janelas',
  },
});
